import angular from 'angular';
import get from 'lodash/get';

import * as actions from '../../../store/actions';

const mapStateToScope = (state) => ({
  activeOrganizationSubmission: state.organization.activeOrganizationSubmission,
});

angular
  .module('myConsultApp')
  .controller(
    'organizationSubmissionProcessingController',
    ($ngRedux, $scope, $rootScope, $timeout, $filter, $http, ENV) => {

      $scope.currentTab = 'find';
      $scope.nextTab = '';
      $scope.tabs = ['find', 'approve'];
      $scope.createNewOrganization = false;
      $scope.createdOrganization = false;
      $scope.selectedClinic = null;
      $scope.isUpdating = false;
      $scope.states = [];

      $scope.init = () => {
        $scope.unsubscribe = $ngRedux.connect(mapStateToScope, actions)($scope);
        $scope.loadStates();
      };

      $scope.loadStates = () => {
        $scope.getOrganizationStates($http, ENV).then((states) => {
          $timeout(() => {
            $scope.states = states;
          });
        });
      };

      $scope.onTabChange = (nextTab) => {
        if(nextTab == 'approve' && !$scope.selectedClinic){
          return;
        }
        if ($scope.curretTab !== nextTab) {
          $scope.nextTab = nextTab;
          $scope.currentTab = $scope.nextTab;
        }
        $('.create-edit-organization-container').scrollTop(0);
      };

      $scope.createOrganizationChange = () => {
        $('.create-edit-organization-container').scrollTop(0);
        if(!$scope.createNewOrganization) {
          $scope.searchGeoCode('zipcode');
          $scope.createNewOrganization = true;
        } else {
          $scope.createNewOrganization = false;
        }
      };

      $scope.onSelectClinicFromPicker = (clinic) => {
        $scope.selectedClinic = clinic;
        $scope.showResultsHeader = false;
        $(".create-edit-organization-container").scrollTop($(".create-edit-organization-container")[0].scrollHeight + 150);
      };

      $scope.onDeselectClinicFromPicker = () => {
        $scope.selectedClinic = null;
      };

      $scope.setOrganizationCreate = () => {
        $scope.creatingOrganization = {
          name: $scope.activeOrganizationSubmission.name,
          is_active: true,
          type_id: 5,
          mdm_id: '',
          s7_id: '',
          phone: '',
          address_1: '',
          address_2: '',
          zipcode: $scope.activeOrganizationSubmission.zipcode,
          city: $scope.activeOrganizationSubmission.city,
          state: $scope.activeOrganizationSubmission.state,
          latitude: '',
          longitude: '',
          directory_type: ['petcare-rewards'],
        };
      }

      $scope.clearOrganizationCreate = () => {
        $scope.isGeoCoding = false;
        $scope.creatingOrganization = {
          name: '',
          is_active: true,
          type_id: 5,
          mdm_id: '',
          s7_id: '',
          phone: '',
          address_1: '',
          address_2: '',
          zipcode: '',
          city: '',
          state: '',
          latitude: '',
          longitude: '',
          directory_type: ['petcare-rewards'],
        };
        $scope.creatingSuccess = false;
        $scope.isCreating = false;
        if ($scope.createForm) {
          $scope.createForm.$setPristine();
          $scope.createForm.$setUntouched();
        }
        $scope.resetCreatingError();
      };

      $scope.resetCreatingError = () => {
        $scope.creatingError = {
          details: '',
          highlightedFields: {
            name: [],
            mdm_id: [],
            s7_id: [],
            phone: [],
            address_1: [],
            address_2: [],
            zipcode: [],
          },
        };
      };

      $scope.submitOrganizationCreate = () => {
        $scope.isCreating = true;
        const data = {
          organization: $scope.sanitizeData({
            ...$scope.creatingOrganization,
            applications: [{ is_active: true, slug: 'loyalty' }],
          }),
        };
        if (!data.organization.latitude) {
          data.organization.latitude = null;
        }
        if (!data.organization.longitude) {
          data.organization.longitude = null;
        }
        if (!data.organization.phone) {
          delete data.organization.phone;
        }

        $scope.resetCreatingError();

        $scope
          .createOrganization($http, ENV, data)
          .then((res) => {
            $scope.$apply(() => {
              $scope.isCreating = false;
              $scope.createdOrganization = true;
              $scope.selectedClinic = res;
              $scope.createNewOrganization = false;
            });
          })
          .catch((error) => {
            $scope.isCreating = false;
            $scope.applyError(error, 'create');
          });
      };

      $scope.searchGeoCode = (field) => {
        const organizationData = $scope.creatingOrganization;

        if (!organizationData[field]) {
          return;
        }

        if (
          (field === 'zipcode' &&
            organizationData.zipcode.length > 3) ||
          (field === 'zipcode' &&
            organizationData.zipcode.length > 3 &&
            $scope.activeOrganization.zipcode !== organizationData.zipcode) ||
          (field === 'city' &&
            get($scope.activeOrganization, 'city.name', '') !== organizationData.city) ||
          (field === 'state' &&
            get($scope.activeOrganization, 'state.abbreviation', '') !== organizationData.state) ||
          (field === 'address' &&
            $scope.activeOrganization.address_1 !== organizationData.address_1)
        ) {
          $scope.isGeoCoding = true;
          const addresses = [];
          if (organizationData.address_1) addresses.push(organizationData.address_1);
          if (organizationData.address_2) addresses.push(organizationData.address_2);

          let address;

          if (field === 'zipcode') {
            address = {
              address: addresses.toString(),
              city: '',
              state: '',
              zipcode: organizationData.zipcode,
            };
          } else if (field === 'city') {
            address = {
              address: addresses.toString(),
              city: organizationData.city,
              state: '',
              zipcode: organizationData.zipcode,
            };
          } else {
            address = {
              address: addresses.toString(),
              city: organizationData.city,
              state: organizationData.state,
              zipcode: organizationData.zipcode,
            };
          }

          $scope.getGeoCode($http, ENV, address).then((geoCode) => {
            $timeout(() => {
              if (Object.keys(geoCode).length === 0) {
                $scope[`creatingError`].highlightedFields[field] = [
                  `Invalid ${field}`,
                ];
                $scope.isGeoCoding = false;
                return;
              }

              $scope[`creatingOrganization`].latitude = geoCode.latitude;
              $scope[`creatingOrganization`].longitude = geoCode.longitude;
              $scope[`creatingOrganization`].city = geoCode.city;
              $scope[`creatingOrganization`].state = geoCode.state;

              if (
                ((field === 'zipcode' &&
                  geoCode.zipcode !== $scope[`creatingOrganization`].zipcode) ||
                  (field === 'city' &&
                    geoCode.city !== $scope[`creatingOrganization`].city) ||
                  (field === 'state' &&
                    geoCode.state !== $scope[`creatingOrganization`].state))
              ) {
                $scope[`creatingOrganization`].latitude = '';
                $scope[`creatingOrganization`].longitude = '';
                $scope[`creatingOrganization`].city = '';
                $scope[`creatingOrganization`].state = '';
                $scope[`creatingError`].highlightedFields.zipcode = [
                  'The coordinates for this address could not be found. Please try changing the state or manually populate the latitude and longitude for this organization.',
                ];
              }
              $scope.isGeoCoding = false;
            });
          });
        }
      };

      $scope.sanitizeData = (data) => {
        return Object.keys(data).reduce((acc, key) => {
          acc[key] = data[key] === '' ? null : data[key];
          return acc;
        }, {});
      };

      $scope.applyError = (error, createOrEdit = 'create') => {
        $timeout(() => {
          const errorKey = createOrEdit === 'create' ? 'creatingError' : 'editingError';
          if (error.status === 500) {
            $scope[errorKey].details =
              'There was an error with your request. Please try again in a few minutes.';
          } else if (error.status === 400) {
            $scope[errorKey].details = 'Please fix the highlighted field(s).';
            $scope[errorKey].highlightedFields = error.data.organization;
            if (error.data.organization.non_field_errors) {
              $scope[errorKey].details = error.data.organization.non_field_errors[0];
            }
          } else {
            $scope[errorKey].details =
              get(error, 'data.organization.detail') || get(error, 'statusText');
          }
        });
      };

      $scope.clearErrorField = (valueKey) => {
        $scope[`creatingError`].highlightedFields[valueKey] = [];
        $scope[`creatingError`].details = '';
      };

      $scope.updateOrganizationSubmissionSubmit = () => {
        $scope.isUpdating = true;
        var data = {
          'organization-submissions': {
            'organization_id': $scope.selectedClinic.id
          }
        };
        $scope.updateOrganizationSubmission($http, ENV, $scope.activeOrganizationSubmission.id, data)
          .then(() => {
            $scope.$apply(() => {
              $scope.isUpdating = false;
              $rootScope.getData();
              $scope.closeProcessOrganizationSubmission();
            });
          })
          .catch((error) => {
            $scope.isUpdating = false;
          });
      };


      $scope.init();
      $scope.clearOrganizationCreate();

      const activeOrganizationSubmissionListener = $scope.$watch('activeOrganizationSubmission', () => {
        if ($scope.activeOrganizationSubmission) {
          $scope.setOrganizationCreate();
        } else {
          $scope.clearOrganizationCreate();
        }
      });

      const componentVisibleListener = $rootScope.$watch('componentOpened', () => {
        if (!$rootScope.componentOpened) {
          $scope.resetContainer();
        }
        $('.create-edit-organization-container').scrollTop(0);
      });

      $scope.resetContainer = () => {
        $scope.isUpdating = false;
        $scope.currentTab = 'find';
        $scope.nextTab = '';
        $scope.tabs = ['find', 'approve'];
        $scope.createNewOrganization = false;
        $scope.createdOrganization = false;
        $scope.selectedClinic = null;
        $scope.clearOrganizationCreate();
        $scope.clearOrganizationSubmission();
        $('.create-edit-organization-container').scrollTop(0);
      }

      $scope.closeProcessOrganizationSubmission = () => {
        $rootScope.closeComponent();
        $scope.resetContainer();
      };

      $scope.$on('$destroy', () => {
        $scope.unsubscribe();
        componentVisibleListener();
        activeOrganizationSubmissionListener();
        $scope.resetContainer();
      });
    },
  )
  .directive('organizationSubmissionProcessing', () => {
    return {
      templateUrl: 'templates/v2/organization-submission-processing.html',
    };
  });
